import * as React from 'react'
import type { SVGProps } from 'react'

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 244.35 229.57"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        style={{
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '4px',
        }}
      >
        <path
          d="M193.31,86.15c-.26-2.84-1.59-5.36-3.58-7.17h.32v-11.79c0-11.32-1.33-22.59-3.97-33.6l-1.2-5.02c-.99-4.15-4.71-7.08-8.98-7.08h0v56.63c-2.22,1.57-3.83,3.93-4.43,6.67l-.15-.26-10.21,5.9c-9.8,5.66-18.9,12.45-27.11,20.23l-3.75,3.55c-3.1,2.94-3.78,7.62-1.64,11.31h0l49.05-28.32c1.41.65,2.98,1.03,4.63,1.03,1.17,0,2.3-.18,3.36-.52l-.15.26,10.21,5.9c9.8,5.66,20.23,10.14,31.08,13.36l4.95,1.47c4.09,1.21,8.49-.54,10.62-4.23h0l-49.04-28.31Z"
          style={{ fill: 'none', stroke: 'currentColor' }}
        />
        <circle
          cx="182.29"
          cy="87.16"
          r="11.08"
          style={{ fill: 'none', stroke: 'currentColor' }}
        />
        <polygon
          points="170.09 227.57 194.48 227.57 186.52 97.95 178.05 97.95 170.09 227.57"
          style={{ fill: 'none', stroke: 'currentColor' }}
        />
        <circle
          cx="34.16"
          cy="34.16"
          r="19.77"
          style={{ fill: 'none', stroke: 'currentColor' }}
          transform="translate(-11.99 19.88) rotate(-27.8)"
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="34.16"
          x2="34.16"
          y1="8.1"
          y2="2"
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="15.73"
          x2="11.42"
          y1="15.73"
          y2="11.42"
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="8.1"
          x2="2"
          y1="34.16"
          y2="34.16"
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="15.73"
          x2="11.42"
          y1="52.58"
          y2="56.9"
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="34.16"
          x2="34.16"
          y1="60.21"
          y2="66.32"
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="52.58"
          x2="56.9"
          y1="52.58"
          y2="56.9"
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="60.21"
          x2="66.32"
          y1="34.16"
          y2="34.16"
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="52.58"
          x2="56.9"
          y1="15.73"
          y2="11.42"
        />
        <polygon
          points="134.37 200.64 30.41 200.64 42.63 148 122.16 148 134.37 200.64"
          style={{ fill: 'none', stroke: 'currentColor' }}
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="66.26"
          x2="69.26"
          y1="200.64"
          y2="148"
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="100.26"
          x2="96.26"
          y1="200.64"
          y2="148"
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="37.82"
          x2="127.96"
          y1="174.32"
          y2="174.32"
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="82.26"
          x2="82.39"
          y1="200.64"
          y2="227.57"
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="221.04"
          x2="24.05"
          y1="227.57"
          y2="227.57"
        />
        <path
          d="M81.07,57.2c-.26-1.15-.4-2.34-.4-3.57,0-8.74,7.08-15.82,15.82-15.82s15.82,7.08,15.82,15.82-7.08,15.82-15.82,15.82h-48.63"
          style={{ fill: 'none', stroke: 'currentColor' }}
        />
        <path
          d="M118.64,80.82c-.26-1.15-.4-2.34-.4-3.57,0-8.74,7.08-15.82,15.82-15.82s15.82,7.08,15.82,15.82-7.08,15.82-15.82,15.82H48.12"
          style={{ fill: 'none', stroke: 'currentColor' }}
        />
      </g>
    </svg>
  )
}

export default Icon
